export const mockData = {
  hero: {
    title: "Door-to-Door Fundraising meistern",
    subtitle: "In nur 2 Wochen",
    description: "Professionelles Coaching mit aktiver Begleitung, perfekter Vorbereitung und abendlichem Trockentraining für NGO-Fundraiser.",
    cta: "Jetzt Beratungsgespräch buchen"
  },
  
  about: {
    title: "Über das Coaching",
    description: "Als erfahrener Fundraising-Coach für das Rote Kreuz biete ich ein intensives 2-Wochen-Programm, das Sie zum Door-to-Door Experten macht. Mit praktischer Begleitung, gezielter Vorbereitung und täglichem Training erreichen Sie messbare Erfolge.",
    stats: [
      { value: "2 Wochen", label: "Intensiv-Training" },
      { value: "100%", label: "Praxisbezogen" },
      { value: "5+", label: "Jahre Erfahrung" }
    ]
  },
  
  services: [
    {
      id: 1,
      title: "Aktive Begleitung",
      description: "Ich begleite Sie direkt bei Ihrer Door-to-Door Arbeit und gebe Ihnen sofortiges Feedback und Verbesserungsvorschläge in Echtzeit.",
      icon: "Users"
    },
    {
      id: 2,
      title: "Perfekte Vorbereitung",
      description: "Gemeinsam erarbeiten wir Ihre individuelle Strategie, Gesprächsleitfäden und Techniken für erfolgreiche Spendenakquise.",
      icon: "Target"
    },
    {
      id: 3,
      title: "Abendliches Training",
      description: "In täglichen Trockentrainings üben wir Gesprächssituationen, Einwandbehandlung und optimieren Ihre Performance kontinuierlich.",
      icon: "Award"
    }
  ],
  
  testimonials: {
    trainee: [
      {
        id: 1,
        name: "Jannik Riepe",
        role: "11 reviews · vor 4 Monaten",
        text: "Das Coaching hat mir wirklich extrem geholfen – gerade im Bereich Fundraising und Dialog habe ich in den zwei Wochen sehr viel dazugelernt und fühle mich jetzt deutlich sicherer. Besonders Nico war top: sehr nett, kompetent und immer unterstützend. Insgesamt kann ich das Coaching auf jeden Fall weiterempfehlen.",
        rating: 5
      },
      {
        id: 2,
        name: "Dana Miceli",
        role: "1 review · vor 3 Monaten",
        text: "Unglaublich wertvolle Ausbildung die meine eigene Kompetenz um 100% gesteigert hat. Absolut zu empfehlen. Außerdem ist Nico echt ein cooler Typ mit dem es einfach Spaß macht :-)",
        rating: 5
      },
      {
        id: 3,
        name: "Fabio",
        role: "1 review · vor 3 Monaten",
        text: "Nico setzt in jeder Hinsicht den Maßstab. Fachlich extrem stark, menschlich noch stärker – er schafft es, Wissen so klar und praxisnah zu vermitteln, dass man es sofort umsetzt. Gleichzeitig motiviert er auf eine Art, die unter die Haut geht und nachhaltig verändert. Wer bei ihm lernt, entwickelt sich nicht nur im Skill, sondern im ganzen Mindset auf ein neues Level.",
        rating: 5
      },
      {
        id: 4,
        name: "Julius B",
        role: "8 reviews · vor 4 Monaten",
        text: "Absolute Empfehlung! Man merkt, wie Nico wirkliches Interesse hat einen perfekt auszubilden. Ich konnte sehr viel mitnehmen. Push it!",
        rating: 5
      }
    ],
    clients: [
      {
        id: 1,
        name: "Marc Dietrich",
        role: "Kreisverbandschef DRK Neuss",
        text: "Es war die erste Aktion, bei denen keine Beschwerden weder intern noch extern aufgetreten sind. Uns wurde von den gewonnen Mitgliedern bestätigt, dass die Botschafter freundlich, kompetent und professionell aufgetreten sind. Die Vorbereitung war im Hinblick auf die Kenntnisse über das DRK sehr gut. Die Zusammenarbeit verlief störungsfrei und in angenehmenen Atmosphäre.",
        rating: 5
      }
    ]
  }
};